<template>
  <div class="tab-dialog-box" style="position: relative;">
    <el-form ref="QueryUserSalaryFilter" :model="QueryUserSalary" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="部门名称" prop="formFilter.deptName">
          <el-input class="filter-item" v-model="QueryUserSalary.formFilter.deptName"
                    :clearable="true" placeholder="部门名称"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.userName">
          <el-input class="filter-item" v-model="QueryUserSalary.formFilter.userName"
                    :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-form-item label="薪级名称" prop="formFilter.jobLevelName">
          <el-input class="filter-item" v-model="QueryUserSalary.formFilter.jobLevelName"
                    :clearable="true" placeholder="薪级名称"
          />
        </el-form-item>
        <el-form-item label="参与绩效" prop="formFilter.paFlag">
          <el-select class="filter-item" v-model="QueryUserSalary.formFilter.paFlag" :clearable="true" filterable
                     placeholder="参与绩效" :loading="QueryUserSalary.paFlag.impl.loading"
                     @visible-change="QueryUserSalary.paFlag.impl.onVisibleChange"
                     @change="onPaFlagValueChange">
            <el-option v-for="item in QueryUserSalary.paFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="绩效工资" prop="formFilter.paSalary">
          <input-number-range class="filter-item"
                              v-model="QueryUserSalary.formFilter.paSalary" :clearable="true"
                              startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="总金额" prop="formFilter.totalAmount">
          <input-number-range class="filter-item"
                              v-model="QueryUserSalary.formFilter.totalAmount" :clearable="true"
                              startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="工资月份" prop="formFilter.salaryMonth">
          <el-date-picker class="filter-item" v-model="QueryUserSalary.formFilter.salaryMonth" :clearable="true" align="left"
                      range-separator="-" start-placeholder="开始月份" end-placeholder="结束月份"
                      type="monthrange" format="yyyyMM" value-format="yyyyMM" />
        </el-form-item>
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="QueryUserSalary.formFilter.status" :clearable="true" filterable
                     placeholder="状态" :loading="QueryUserSalary.status.impl.loading"
                     @visible-change="QueryUserSalary.status.impl.onVisibleChange"
                     @change="onStatusValueChange">
            <el-option v-for="item in QueryUserSalary.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetQueryUserSalary">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshQueryUserSalary(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="QueryUserSalary" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="14" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>员工列表</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paPayrollLine" :data="QueryUserSalary.PaPayrollLine.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryUserSalary.PaPayrollLine.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="QueryUserSalary.PaPayrollLine.impl.currentRowChange"
                          height="450px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryUserSalary.PaPayrollLine.impl.getTableIndex" />
                  <el-table-column label="工资月份" prop="salaryMonth" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="部门名称" prop="deptName" sortable="custom" align="center" width="230px">
                  </el-table-column>
                  <el-table-column label="薪资发放名称" prop="payrollIdDictMap.name" align="center" width="150px" >
                  </el-table-column>
                  <el-table-column label="员工姓名" prop="userName" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="状态" prop="statusDictMap.name" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="总金额" prop="totalAmount" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="薪级名称" prop="jobLevelName" sortable="custom" align="center" width="130px">
                  </el-table-column>
                  <el-table-column label="参与绩效" prop="paFlagDictMap.name" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="目标工作量" prop="goalWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="本次工作量" prop="thisWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="下次工作量" prop="nextWorkNum" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="绩效截止时间" prop="paEndTime" align="center" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.paEndTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="绩效分数" prop="paScore" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="考评时间" prop="assessTime" align="center" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.assessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="考评系数" prop="assessRatio" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="有效分数" prop="assessScore" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="基本工资" prop="baseSalary" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="岗位工资" prop="jobSalary" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="绩效工资" prop="paSalary" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="奖金" prop="bonusAmount" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="扣减金额" prop="deductAmount" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="其他工资" prop="otherSalary" sortable="custom" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="创建人" prop="createUserIdDictMap.name" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="创建时间" prop="createTime" align="center" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="更新人" prop="updateUserIdDictMap.name" align="center" width="100px">
                  </el-table-column>
                  <el-table-column label="更新时间" prop="updateTime" align="center" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.updateTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                    :total="QueryUserSalary.PaPayrollLine.impl.totalCount"
                    :current-page="QueryUserSalary.PaPayrollLine.impl.currentPage"
                    :page-size="QueryUserSalary.PaPayrollLine.impl.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    layout="total, prev, pager, next, sizes"
                    @current-change="QueryUserSalary.PaPayrollLine.impl.onCurrentPageChange"
                    @size-change="QueryUserSalary.PaPayrollLine.impl.onPageSizeChange">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="10" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>工资项目</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paPayrollIndex" :data="QueryUserSalary.PaPayrollIndex.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryUserSalary.PaPayrollIndex.impl.onSortChange"
                          header-cell-class-name="table-header-gray" row-key="id" default-expand-all height="500px"
                >
<!--                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryUserSalary.PaPayrollIndex.impl.getTableIndex" />-->
                  <el-table-column label="名称" prop="name" width="250px">
                  </el-table-column>
                  <el-table-column label="参数" prop="paramVariable" width="200px">
                    <template slot-scope="scope">
                      <span v-if="scope.row.gcode!=='pa_work'">{{scope.row.paramVariable}}</span>
                      <div v-if="scope.row.gcode==='pa_work'">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-tag>权重系数：{{scope.row.pa_work.indexWeightValue}}</el-tag>
                          </el-col>
                          <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                            <el-tag>满分线：{{scope.row.pa_work.fullScoreLine}}%</el-tag>
                          </el-col>
                          <el-col :span="12" v-if="scope.row.code==='work_lv_a_rate'">
                            <el-tag>扣分系数：{{scope.row.pa_work.deductionFactor}}</el-tag>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="指标值" prop="indexValue">
                    <template slot-scope="scope">
                      {{scope.row.indexValue}}
                    </template>
                  </el-table-column>
                  <el-table-column label="金额" prop="indexResult">
                  </el-table-column>
                  <el-table-column label="计算公式" prop="evalFormula">
                  </el-table-column>
                  <el-table-column label="评委评分" prop="judgeScore">
                  </el-table-column>
                  <el-table-column label="评委评级" prop="judgeAssessLv">
                  </el-table-column>
                  <el-table-column label="上级评分" prop="superiorScore">
                  </el-table-column>
                  <el-table-column label="自评得分" prop="selfScore">
                  </el-table-column>
                  <el-table-column label="自评描述" prop="selfAssess">
                  </el-table-column>
                  <el-table-column label="自评时间" prop="selfAssessTime">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.selfAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="上级" prop="superiorIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="上级评分描述" prop="superiorAssess" width="100px">
                  </el-table-column>
                  <el-table-column label="上级评价时间" prop="superiorAssessTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.superiorAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="评委" prop="judgeIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="评委评价内容" prop="judgeAssess" width="100px">
                  </el-table-column>
                  <el-table-column label="评委评价时间" prop="judgeAssessTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.judgeAssessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaPayrollLineController, PaPayrollIndexController, DictionaryController } from '@/api';

export default {
  name: 'PayrollUserSalaryRecord',
  props: {
    payrollId: {
      default: undefined
    },
    userId: {
      default: undefined
    },
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaPayrollLine: {
          id: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptName: undefined,
          deptTid: undefined,
          userId: undefined,
          userName: undefined,
          jobLevelId: undefined,
          jobLevelName: undefined,
          status: undefined,
          paFlag: undefined,
          goalScore: undefined,
          paEndTime: undefined,
          paScore: undefined,
          assessTime: undefined,
          assessRatio: undefined,
          assessScore: undefined,
          baseSalary: undefined,
          jobSalary: undefined,
          paSalary: undefined,
          bonusAmount: undefined,
          deductAmount: undefined,
          otherSalary: undefined,
          totalAmount: undefined,
          contextData: undefined,
          salaryMonth: undefined,
          detail: undefined,
          name: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paPayrollIndex: {
          },
          isDatasourceInit: false
        }
      },
      QueryUserSalary: {
        formFilter: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          paFlag: undefined,
          paSalary: [],
          totalAmount: [],
          salaryMonth: [],
          status: undefined
        },
        formFilterCopy: {
          deptName: undefined,
          userName: undefined,
          jobLevelName: undefined,
          paFlag: undefined,
          paSalary: [],
          totalAmount: [],
          salaryMonth: [],
          status: undefined
        },
        PaPayrollLine: {
          impl: new TableWidget(this.loadPaPayrollLineWidgetData, this.loadPaPayrollLineVerify, true, true, 'userName', 1)
        },
        PaPayrollIndex: {
          impl: new TableWidget(this.loadPaPayrollIndexWidgetData, this.loadPaPayrollIndexVerify, false, false, 'sort', 1)
        },
        paFlag: {
          impl: new DropdownWidget(this.loadPaFlagDropdownList)
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        PaPayrollLIneDiv: {
          isInit: false
        },
        PaPayrollIndexDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      // this.$refs.paPayrollLine.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetQueryUserSalary () {
      this.$refs.QueryUserSalaryFilter.resetFields();
      this.refreshQueryUserSalary(true);
    },
    /**
     * 工资发放行数据获取函数，返回Promise
     */
    loadPaPayrollLineWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paPayrollLineDtoFilter: {
          deptName: this.QueryUserSalary.formFilterCopy.deptName,
          userName: this.QueryUserSalary.formFilterCopy.userName,
          jobLevelName: this.QueryUserSalary.formFilterCopy.jobLevelName,
          status: this.QueryUserSalary.formFilterCopy.status,
          paFlag: this.QueryUserSalary.formFilterCopy.paFlag,
          paSalaryStart: Array.isArray(this.QueryUserSalary.formFilterCopy.paSalary) ? this.QueryUserSalary.formFilterCopy.paSalary[0] : undefined,
          paSalaryEnd: Array.isArray(this.QueryUserSalary.formFilterCopy.paSalary) ? this.QueryUserSalary.formFilterCopy.paSalary[1] : undefined,
          totalAmountStart: Array.isArray(this.QueryUserSalary.formFilterCopy.totalAmount) ? this.QueryUserSalary.formFilterCopy.totalAmount[0] : undefined,
          totalAmountEnd: Array.isArray(this.QueryUserSalary.formFilterCopy.totalAmount) ? this.QueryUserSalary.formFilterCopy.totalAmount[1] : undefined,
          salaryMonthStart: Array.isArray(this.QueryUserSalary.formFilterCopy.salaryMonth) ? this.QueryUserSalary.formFilterCopy.salaryMonth[0] : undefined,
          salaryMonthEnd: Array.isArray(this.QueryUserSalary.formFilterCopy.salaryMonth) ? this.QueryUserSalary.formFilterCopy.salaryMonth[1] : undefined
        }
      }
      if (this.payrollId) {
        params.paPayrollLineDtoFilter.payrollId = this.payrollId;
      }
      return new Promise((resolve, reject) => {
        PaPayrollLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.QueryUserSalary.PaPayrollLine.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.QueryUserSalary.PaPayrollLine.impl.currentRow.id, 'id');
              this.$refs.paPayrollLine.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 工资发放行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaPayrollLineVerify () {
      this.QueryUserSalary.formFilterCopy.deptName = this.QueryUserSalary.formFilter.deptName;
      this.QueryUserSalary.formFilterCopy.userName = this.QueryUserSalary.formFilter.userName;
      this.QueryUserSalary.formFilterCopy.jobLevelName = this.QueryUserSalary.formFilter.jobLevelName;
      this.QueryUserSalary.formFilterCopy.status = this.QueryUserSalary.formFilter.status;
      this.QueryUserSalary.formFilterCopy.paFlag = this.QueryUserSalary.formFilter.paFlag;
      this.QueryUserSalary.formFilterCopy.paSalary = this.QueryUserSalary.formFilter.paSalary;
      this.QueryUserSalary.formFilterCopy.totalAmount = this.QueryUserSalary.formFilter.totalAmount;
      this.QueryUserSalary.formFilterCopy.salaryMonth = this.QueryUserSalary.formFilter.salaryMonth;
      return true;
    },
    /**
     * 工资发放指标数据获取函数，返回Promise
     */
    loadPaPayrollIndexWidgetData (params) {
      if (params == null) params = {};
      let payrollLineId = (this.QueryUserSalary.PaPayrollLine.impl.currentRow || {}).id;
      if (payrollLineId === undefined || payrollLineId === 0) {
        return;
      }
      if (params == null) params = {};
      params = {
        ...params,
        paPayrollIndexDtoFilter: {
          payrollLineId: payrollLineId
        }
      }
      return new Promise((resolve, reject) => {
        PaPayrollIndexController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'index') {
              // dataList[i].levelCodeDictMap.name = '';
              // dataList[i].detail = '';
            }
            if (dataList[i].gcode === 'pa_work') {
              dataList[i].pa_work = JSON.parse(dataList[i].detail);
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 工资发放指标数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaPayrollIndexVerify () {
      return true;
    },
    /**
     * 参与绩效下拉数据获取函数
     */
    loadPaFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 参与绩效选中值改变
     */
    onPaFlagValueChange (value) {
    },
    /**
     * 状态下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 状态选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 更新员工列表
     */
    refreshPaPayrollLIneDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryUserSalary.PaPayrollLine.impl.refreshTable(true, 1);
      } else {
        this.QueryUserSalary.PaPayrollLine.impl.refreshTable();
      }
      this.QueryUserSalary.PaPayrollLIneDiv.isInit = true;
      this.refreshPaPayrollIndexDivWidget();
    },
    /**
     * 更新工资项目
     */
    refreshPaPayrollIndexDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      } else {
        this.QueryUserSalary.PaPayrollIndex.impl.refreshTable();
      }
      this.QueryUserSalary.PaPayrollIndexDiv.isInit = true;
    },
    /**
     * 更新员工薪资历史
     */
    refreshQueryUserSalary (reloadData = false) {
      if (reloadData) {
        this.QueryUserSalary.PaPayrollLine.impl.refreshTable(true, 1);
      } else {
        this.QueryUserSalary.PaPayrollLine.impl.refreshTable();
      }
      if (reloadData) {
        this.QueryUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      } else {
        this.QueryUserSalary.PaPayrollIndex.impl.refreshTable();
      }
      if (!this.QueryUserSalary.isInit) {
        // 初始化下拉数据
      }
      this.QueryUserSalary.isInit = true;
    },
    onResume () {
    },
    /**
     * 获取工资发放行详细信息
     */
    loadPaPayrollLineData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaPayrollLine.isDatasourceInit) {
          if (
            this.payrollId == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.payrollId
          };
          PaPayrollLineController.view(this, params).then(res => {
            this.formData.PaPayrollLine = {...res.data, isDatasourceInit: true};
            if (this.formData.PaPayrollLine.paFlagDictMap && this.QueryUserSalary.paFlag.impl.dirty) {
              this.QueryUserSalary.paFlag.impl.dropdownList = [this.formData.PaPayrollLine.paFlagDictMap];
            }
            if (this.formData.PaPayrollLine.statusDictMap && this.QueryUserSalary.status.impl.dirty) {
              this.QueryUserSalary.status.impl.dropdownList = [this.formData.PaPayrollLine.statusDictMap];
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaPayrollIndex: {
          id: undefined,
          payrollId: undefined,
          pid: undefined,
          payrollLineId: undefined,
          name: undefined,
          code: undefined,
          gcode: undefined,
          type: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          indexResult: undefined,
          sort: undefined,
          detail: undefined,
          remark: undefined,
          selfId: undefined,
          selfScore: undefined,
          selfAssess: undefined,
          selfAssessTime: undefined,
          superiorScore: undefined,
          superiorAssess: undefined,
          superiorAssessTime: undefined,
          superiorId: undefined,
          judgeAssessLv: undefined,
          judgeId: undefined,
          judgeAssess: undefined,
          judgeAssessTime: undefined,
          judgeScore: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaPayrollLine: {
          id: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptName: undefined,
          deptTid: undefined,
          userId: undefined,
          userName: undefined,
          jobLevelId: undefined,
          jobLevelName: undefined,
          status: undefined,
          paFlag: undefined,
          goalScore: undefined,
          goalWorkNum: undefined,
          thisWorkNum: undefined,
          nextWorkNum: undefined,
          paEndTime: undefined,
          paScore: undefined,
          assessTime: undefined,
          assessRatio: undefined,
          assessScore: undefined,
          baseSalary: undefined,
          jobSalary: undefined,
          paSalary: undefined,
          bonusAmount: undefined,
          deductAmount: undefined,
          otherSalary: undefined,
          totalAmount: undefined,
          contextData: undefined,
          salaryMonth: undefined,
          detail: undefined,
          name: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paPayrollIndex: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshQueryUserSalary();
    }
  },
  computed: {
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    'QueryUserSalary.PaPayrollLine.impl.currentRow': {
      handler (newValue) {
        this.QueryUserSalary.PaPayrollIndex.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
